var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflineDeliveryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.0859V18.4995C4.5 18.6985 4.57902 18.8892 4.71967 19.0299C4.86032 19.1705 5.05109 19.2495 5.25 19.2495H18.75C18.9489 19.2495 19.1397 19.1705 19.2803 19.0299C19.421 18.8892 19.5 18.6985 19.5 18.4995V12.0861",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06573 2.75H18.9343C19.0973 2.75 19.2558 2.80309 19.3859 2.90124C19.516 2.99939 19.6106 3.13725 19.6554 3.29396L21 8H3L4.34458 3.29396C4.38936 3.13725 4.48396 2.99939 4.61408 2.90124C4.7442 2.80309 4.90274 2.75 5.06573 2.75Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8V9.5C9 10.2956 8.68393 11.0587 8.12132 11.6213C7.55871 12.1839 6.79565 12.5 6 12.5C5.20435 12.5 4.44129 12.1839 3.87868 11.6213C3.31607 11.0587 3 10.2956 3 9.5V8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V9.5C15 10.2956 14.6839 11.0587 14.1213 11.6213C13.5587 12.1839 12.7956 12.5 12 12.5C11.2044 12.5 10.4413 12.1839 9.87868 11.6213C9.31607 11.0587 9 10.2956 9 9.5V8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8V9.5C21 10.2956 20.6839 11.0587 20.1213 11.6213C19.5587 12.1839 18.7956 12.5 18 12.5C17.2044 12.5 16.4413 12.1839 15.8787 11.6213C15.3161 11.0587 15 10.2956 15 9.5V8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineDeliveryIcon);
export default __webpack_public_path__ + "static/media/offline-delivery-icon.849956dc6c1977369a7b8e69771c1e99ae3d3b80ebcf2ba05bdaabaf1884065b.svg";
export { ForwardRef as ReactComponent };